import { IReduxAction } from '../../types';
import AUTH_ACTIONS from './actionTypes';

export const logout = (): IReduxAction => ({ type: AUTH_ACTIONS.LOGOUT });

export const toggleRememberMe = (value: boolean): IReduxAction => ({
  type: AUTH_ACTIONS.TOGGLE_REMEMBER_ME,
  payload: value,
});
